/**
 * Upload Proof Use Case
 * Uploads a proof file for a compliance
 */

import { ComplianceProofEntity } from "../../entities";
import { TenantComplianceRepository } from "../../repositories";

export class UploadProofUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(
    complianceId: number,
    file: File,
    proofType?: string,
    description?: string,
    isPrimary?: boolean
  ): Promise<ComplianceProofEntity> {
    return await this.repository.uploadProof(
      complianceId,
      file,
      proofType,
      description,
      isPrimary
    );
  }
}

